import { Features } from 'generated/featureDefinitions'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'

export interface IBookingAvailability {
  available: boolean
  usage?: number
  usageLimit?: number
  closeToLimit?: boolean
  limitReached?: boolean
}

export const useBookingLimits = () => {
  const { loading, refetch, featureAvailability } = useFeatureAvailability(
    Features.space_control_spaces
  )

  const featureEnabled = 'usageLimit' in featureAvailability

  const featureAvailable = () => {
    return !!(featureEnabled && featureAvailability.available)
  }

  const featureUsage = () => {
    return (featureEnabled && featureAvailability.usage) || 0
  }

  const unlimitedFeature = -1

  const featureUsageLimit = () => {
    return (featureEnabled && featureAvailability.usageLimit) || unlimitedFeature
  }

  const limitReached = () => {
    if (!featureEnabled) return false
    if (featureUsageLimit() == unlimitedFeature) return false

    return featureUsage() >= featureUsageLimit()
  }

  const closeToLimit = () => {
    if (!featureEnabled) return false
    if (featureUsageLimit() == unlimitedFeature) return false
    if (limitReached()) return false

    return featureUsage() >= Math.trunc(featureUsageLimit() * 0.9)
  }

  const bookingAvailability = ((): IBookingAvailability => {
    const defaultAvailability = {
      available: false,
    }

    if (!featureEnabled) return defaultAvailability

    const available = featureAvailability.available

    if (!('usageLimit' in featureAvailability) && !available) return defaultAvailability

    return {
      available: featureAvailable(),
      usage: featureUsage(),
      usageLimit: featureUsageLimit(),
      limitReached: limitReached(),
      closeToLimit: closeToLimit(),
    }
  })()

  return {
    loading,
    refetch,
    bookingAvailability,
  }
}
